import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const addLevel2Slice = createSlice({
  name: "addLevel2",
  initialState,
  reducers: {
    addLevel2Requested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    addLevel2RequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    addLevel2RequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  addLevel2Requested,
  addLevel2RequestFailed,
  addLevel2RequestSucceeded,
} = addLevel2Slice.actions;

export default addLevel2Slice.reducer;
